import { BaseService, Service } from "/@/cool";
@Service("agent")
class Agent extends BaseService {
	constructor() {
		super();

		let prefix = "";
		if (this.namespace) {
			prefix = this.namespace.replace(/\//g, ":") + ":";
		}

		this.permission["sharingList"] = prefix + "sharingList";
		this.permission["bindUser"] = prefix + "bindUser";
		this.permission["queryUser"] = prefix + "queryUser";
	}

	sharingList(data: any) {
		return this.request({
			url: "/sharingList",
			method: "POST",
			data
		});
	}
	bindUser(data: any) {
		return this.request({
			url: "/bindUser",
			method: "POST",
			data
		});
	}
	queryUser(data: any) {
		return this.request({
			url: "/queryUser",
			method: "POST",
			data
		});
	}
}
export default Agent;
